// API types — match the BFF schema. No fixtures.

export type DealStage = 'sourced' | 'screening' | 'kyc' | 'dd' | 'term-sheet' | 'closing' | 'closed' | 'killed';

export type Friend = {
  id: string;
  groupId: string;
  name: string;
  email: string;
  city?: string | null;
  timezone?: string | null;
  sectors?: string[] | null;
  online?: boolean | null;
  createdAt?: number;
};

export type DealParticipant = {
  dealId: string;
  friendId: string;
  role: 'lead' | 'contributor' | 'silent' | 'observer';
  splitBp: number;
};

export type Blocker = {
  id: string;
  dealId: string;
  description: string;
  ownerId: string;
  resolvedAt?: number | null;
  createdAt: number;
};

export type LedgerEntry = {
  id: string;
  groupId: string;
  dealId?: string | null;
  type: 'cost' | 'revenue' | 'reimbursement' | 'settlement';
  description: string;
  amount: number;
  currency: string;
  paidByFriendId?: string | null;
  date: string;
};

export type Deal = {
  id: string;
  groupId: string;
  name: string;
  type: string;
  sector: string;
  geography?: string | null;
  ticketSize: number;
  currency: string;
  stage: DealStage;
  heat: 'hot' | 'warm' | 'cold' | 'dead';
  leadFriendId: string;
  expectedRevenue?: number | null;
  expectedMargin?: number | null;
  visibility?: string;
  createdAt: number;
};

export type Hang = {
  id: string;
  groupId: string;
  city: string;
  venue?: string | null;
  startsAt: number;
  endsAt?: number | null;
  status: 'planned' | 'impromptu' | 'past' | 'cancelled';
  trigger?: string | null;
  notes?: string | null;
};

export type Artifact = {
  id: string;
  groupId: string;
  dealId?: string | null;
  type: string;
  title: string;
  version: number;
  producedByAgent?: string | null;
  createdAt: number;
};

export type EventRow = {
  id: string;
  groupId: string;
  actorType: 'friend' | 'agent' | 'system';
  actorId?: string | null;
  agentName?: string | null;
  action: string;
  subjectType?: string | null;
  subjectId?: string | null;
  data?: any;
  at: number;
};

export const STAGE_LABEL: Record<DealStage, string> = {
  sourced: 'Sourced',
  screening: 'Screening',
  kyc: 'KYC',
  dd: 'DD',
  'term-sheet': 'Term sheet',
  closing: 'Closing',
  closed: 'Closed',
  killed: 'Killed',
};

export const STAGE_ORDER: DealStage[] = ['sourced','screening','kyc','dd','term-sheet','closing','closed'];
